import React from 'react';
import firebaseAppConfig from '../../components/firebase/firebase-app-config';
import { APP_THEME_LIGHT, APP_THEME_DARK } from '../../components/theme/theme-constants';
import rafflesiaThemeLight from '../theme/rafflesia-theme-light';
import rafflesiaThemeDark from '../theme/rafflesia-theme-dark';
import rafflesiaEnMessages from '../intl/rafflesia-en.json';
import rafflesiaIdMessages from '../intl/rafflesia-id.json';
import rafflesiaRoutes from '../route/rafflesia-routes';
import SeedNotFoundPage from '../../components/page/SeedNotFoundPage';
import { rafflesiaDrawerRoutes, rafflesiaBottomNavMenus } from '../route/rafflesia-drawer-routes';
import rafflesiaD3dPopoverMenus from '../page/rafflesia-d3d-constants';
import { rafflesiaStates } from '../state/rafflesia-states';

const rafflesiaApplicationName = 'Rafflesia';

const rafflesiaAppConfig = {
  ...firebaseAppConfig,

  seedDefaultLocale: 'en',
  intlExtraMessageLocales: {
    en: [
      ...firebaseAppConfig.intlExtraMessageLocales.en,
      rafflesiaEnMessages,
    ],
    id: [
      ...firebaseAppConfig.intlExtraMessageLocales.id,
      rafflesiaIdMessages,
    ],
  },

  themeThemes: {
    [APP_THEME_LIGHT]: rafflesiaThemeLight,
    [APP_THEME_DARK]: rafflesiaThemeDark,
  },

  stateAppStates: rafflesiaStates,

  appRoutes: rafflesiaRoutes,
  notFoundPage: <SeedNotFoundPage applicationName={rafflesiaApplicationName} />,
  applicationName: rafflesiaApplicationName,
  commonComponentProps: {
    ...firebaseAppConfig.commonComponentProps,
    drawerRoutes: rafflesiaDrawerRoutes,
    applicationName: rafflesiaApplicationName,
    popoverMenus: rafflesiaD3dPopoverMenus,
    bottomNavMenus: rafflesiaBottomNavMenus,
  },

  firebaseConfig: {
    apiKey: 'AIzaSyAPeYj3y-cZpC0zRmPq9Gvnh74mgp-ebRc',
    authDomain: 'rafflesia-freesia.firebaseapp.com',
    databaseURL: 'https://rafflesia-freesia.firebaseio.com',
    projectId: 'rafflesia-freesia',
    storageBucket: 'rafflesia-freesia.appspot.com',
    messagingSenderId: '156894277411',
    appId: '1:156894277411:web:1a048965ca904e9de9a696',
    measurementId: 'G-XEZ1CHX8E1',
    firebaseOptions: {
      analytics: false,
      firestore: true,
    },
  },
};

export default rafflesiaAppConfig;
